{{ this.wordCount }} character(s)
<quill-editor class="ql-editor" [styles]="{ height: '400px' }" [format]="'html'" [(ngModel)]="fdescHtml"
  (onEditorCreated)="onEditorCreated($event)"> <!-- (onContentChanged)="onContentChanged($event)" -->
  <div quill-editor-toolbar>
    <!-- Font Size -->
    <span class="ql-formats">
      <select class="ql-size" title="Font Size">
        <option value="4pt">4pt</option>
        <option value="5pt">5pt</option>
        <option value="6pt">6pt</option>
        <option value="7pt">7pt</option>
        <option value="8pt" selected>8pt</option>
        <option value="9pt">9pt</option>
        <option value="10pt">10pt</option>
        <option value="12pt">12pt</option>
        <option value="14pt">14pt</option>
        <option value="15pt">15pt </option>
        <option value="18pt">18pt</option>
        <option value="24pt">24pt</option>
        <option value="36pt">36pt</option>
      </select>
      <select class="ql-font" title="Font">
        <option value="tahoma" selected>Tahoma</option>
        <option value="arial">Arial</option>
        <option value="roboto">Roboto</option>
        <option value="monospace">Monospace</option>
        <option value="cursive">Cursive</option>
      </select>
    </span>

    <span class="ql-formats">
      <button type="button" class="ql-bold" title="Bold(Ctrl+B)"></button>
      <button type="button" class="ql-italic" title="Italic(Ctrl+I)"></button>
      <button type="button" class="ql-underline" title="Underline(Ctrl+U)"></button>
      <button type="button" class="ql-strike" title="Strikethrough"></button>
      <button type="button" class="ql-blockquote" title="Block Quote"></button>
      <button type="button" class="ql-code-block" title="Code Block"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-list" value="ordered" title="Numbered List"></button>
      <button type="button" class="ql-list" value="bullet" title="Bulleted List"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-indent" value="-1" title="Decrease Indent"></button>
      <button type="button" class="ql-indent" value="+1" title="Increase Indent"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-color" title="Font Color">
      </select>

      <select class="ql-background" title="Background Color">
      </select>
    </span>
    <span class="ql-formats">
      <select class="ql-align" title="Alignment">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>

    <span class="ql-formats">
      <button type="button" class="ql-clean" title="Clear Format"></button>
    </span>
  </div>
</quill-editor>